import React from "react";

export default function Feedback({ ...props }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {props.feedback.map(feedback => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            textAlign: "center",
            border: "solid #c5c5c5 2px",
            background: "#e4e4e4"
          }}
        >
          <div
            style={{
              color: "#9c9c9c",
              fontSize: props.questionFontSize
                ? props.questionFontSize
                : "1.4em"
            }}
          >
            {<div dangerouslySetInnerHTML={{ __html: (feedback.question) }} />}
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              style={{
                flex: 1,
                textAlign: "center",
                border: "solid #c5c5c5 2px",
                background: "#fff",
                color: "rgb(234, 29, 19)"
              }}
            >
              {<div dangerouslySetInnerHTML={{ __html: (feedback.incorrect) }} />}
            </div>
            <div
              style={{
                flex: 1,
                textAlign: "center",
                border: "solid #c5c5c5 2px",
                background: "#fff",
                color: "rgb(25, 160, 63)"
              }}
            >
              {<div dangerouslySetInnerHTML={{ __html: (feedback.correct) }} />}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
